import Input from '../../common/Input';
import DatePicker from '../../common/DatePicker';
import Select from '../../common/Select';
import TextArea from '../../common/TextArea';

export const dynamicTypes = {
  paint_list: {
    style: {
      grid: null,
    },
    label: null,
    placeholder: '',
    value: '',
    errors: [],
    rules: {
      title: null,
    },
    system: {
      component: {},
      name: null,
    },
  },
  input: {
    label: null,
    placeholder: 'Fill-in this field',
    value: '',
    errors: [],
    style: {
      grid: null,
    },
    system: {
      component: Input,
      name: null,
    },
    rules: {
      title: null,
    }
  },
  textarea: {
    label: null,
    placeholder: 'Fill-in this field',
    value: '',
    errors: [],
    style: {
      grid: null,
    },
    system: {
      component: TextArea,
      name: null,
    },
    rules: {
      title: null,
    }
  },
  dropdown: {
    source: [],
    label: null,
    placeholder: 'Fill-in this field',
    value: '',
    errors: [],
    style: {
      grid: null,
    },
    system: {
      component: Select,
      name: null,
    },
    rules: {
      title: null,
    }
  },
  number: {
    label: null,
    type: 'number',
    placeholder: 'Fill-in this field',
    value: '',
    errors: [],
    style: {
      grid: null,
    },
    system: {
      component: Input,
      name: null,
    },
    rules: {
      title: null,
    }
  },
  datepicker: {
    label: null,
    placeholder: 'Fill-in this field',
    value: '',
    errors: [],
    style: {
      grid: null,
    },
    system: {
      component: DatePicker,
      name: null,
    },
    rules: {
      title: null,
    },
    timeFormat: true,
  },
};

export const supplies_log = {
  id: 0,

  _system: {
    name: 'Supplies Log',
    relatedTo: 'supplies_log',
  },

  vendorEmail: {
    label: "Vendor's Email",
    placeholder: 'Fill-in this field',
    system: {
      component: Input,
      name: 'vendorEmail',
    },
    value: '',
    errors: [],
    type: 'email',
    name: 'vendorEmail',
    rules: {
      title: "Vendor's Email",
      required: false,
      email: true,
    }
  },

  vendorName: {
    label: "Vendor's Name",
    placeholder: 'Fill-in this field',
    system: {
      component: Input,
      name: 'vendorName',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'vendorName',
    rules: {
      title: "Vendor's Name",
      required: false,
    }
  }
};

export const basic = {
  // supplies_log: [],
  customer: {
    label: 'Customer',
    placeholder: 'Add customer',
    system: {
      name: 'project_id',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'customer',
    rules: {
      title: 'Customer field',
      required: true,
    }
  },
  contacts: {
    label: 'Customer contacts',
    placeholder: 'Select contacts',
    system: {
      name: 'contacts',
    },
    value: [],
    errors: [],
    type: 'text',
    name: 'contacts',
    rules: {
      title: 'Customer contacts field',
      custom: {
        message: 'Customer contacts field is required',
        onValidate: value => Array.isArray(value) && value.length > 0
      }
    }
  },
  project: {
    label: 'Project',
    placeholder: 'Choose project',
    system: {
      name: 'project',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'project',
    rules: {
      title: 'Project field',
      required: true,
    }
  },
  workOrder: {
    label: 'Work Order',
    placeholder: 'Fill-in this field',
    system: {
      name: 'lane_id',
      disabled: false,
      customId: 1,
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'workOrder',
    rules: {
      title: 'Work Order',
      required: true,
    }
  },
  salesRep: {
    label: 'Sales Rep',
    placeholder: 'Choose sales rep',
    system: {
      name: 'sales_rep_id',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'sales_rep_id',
    rules: {
      title: 'Sales Rep field',
      required: true,
    }
  },
};



// WEBPACK FOOTER //
// ./src/containers/WorkOrderAdd/fields.js